import { Row, Col, Container } from "react-bootstrap";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="mt-auto py-2" style={{ backgroundColor: "#0E1920" }}>
      <Container fluid>
        <Row className="text-white justify-content-md-between align-items-center g-0">

          <Col
            xs={12}
            md="auto" 
            className="text-center text-md-start order-1 order-md-0" 
            style={{
              fontFamily: "Inter",
              fontSize: "12px",
              fontWeight: "400",
              lineHeight: "1.2",
              padding: "0 1rem", 
            }}
          >
            © 2025 Monetare. Todos os direitos reservados.
          </Col>
          <Col
            xs={12}
            md="auto"
            className="text-center mt-2 mt-md-0"
            style={{
              fontFamily: "Inter",
              fontSize: "12px",
              fontWeight: "400",
              lineHeight: "1.2",
              padding: "0 1rem", 
            }}
          >
            <Row className="justify-content-center gap-md-3 g-0">
              <Col xs="auto">
                <a
                  className="links"
                  target="_blank"
                  href="https://monetare.com.br/privacy-policy/"
                >
                  Política de Privacidade
                </a>
              </Col>
              <Col xs="auto">
                <a
                  target="_blank"
                  className="links"
                  href="https://monetare.com.br/termo-de-uso/"
                >
                  Termos de Uso
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
